// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1562":"4a389e47","6099":"55389219","8176":"35c241da","9145":"24181706","9201":"e5c4c070"}[chunkId] + ".chunk.css";
};